// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"3f3bafb2","821":"471260b4"}[chunkId] + ".chunk.js";
};